<div class="goreact-modal welcome-tour-dialog" cdkTrapFocus>
	<div class="goreact-modal-header">
		<button type="button" class="close-btn" (click)="close()" [attr.aria-label]="'common_close' | translate">
			<i class="ficon-app-x"></i>
		</button>
	</div>
	<div class="goreact-modal-body">
		<img class="graphic" src="https://staticassets.goreact.com/sparkling-rocket.svg" alt="New Look graphic">
		<p [id]="data.dialogTitleId" class="text" translate="lti-refresh-tour-modal-text"></p>
		<p class="sub-text" translate="lti-refresh-tour-modal-subtext" [translateParams]="translationParams"></p>
	</div>
	<div class="goreact-modal-footer">
		<button class="primary-btn confirm-button" (click)="startTour()" translate="lti-refresh-tour-modal-get_started"></button>
		<button class="tertiary-btn cancel-button" (click)="close()" translate="tour-skip"></button>
	</div>
</div>
